import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { debounceTime } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { CompanyInsightsService } from 'src/app/_services/company-insights.service';
import * as _ from "underscore";
import { PersonSearchService } from 'src/app/_services/person-search.service';

@Component({
  selector: 'app-company-list',
  templateUrl: './company-list.component.html',
  styleUrls: ['./company-list.component.scss']
})
export class CompanyListComponent implements OnInit {

  private typeAheadSubject = new Subject<{event: Event, type:String}>();

  viewMore = false; 
  searchKeyword: string;
  companylist: any[]
  typeahead_search: FormControl = new FormControl(null)
  companycount: any
  typeaheaddata: any[]
  companyfilter_form = new FormGroup({
    industry: new FormControl(null),
    companysize: new FormControl(null),
    hqlocation: new FormControl(null)
  })  
  typeaheadObj: any
  selectedIndustries:any[] = []
  selectedLocations: any[] = []
  companysizes: any[] = []
  industry_typeaheads: any = []
  companysize_typeaheads: any = []
  selectedCompanysize:any[] = []
  hqlocations_typeaheads: any = []
  selectedHqLocation: any[] = []
  showIndustryLoader: boolean =false;
  showCompanysizeLoader: boolean =false;
  showLocationLoader: boolean =false;
  showSearchLoader: boolean =false;
  companypagecount: number = 12
  isViewMore: boolean = true;
  companySortBy:  string = 'employeecountdesc';

  constructor(private CompanyInsightsService: CompanyInsightsService, private route: ActivatedRoute, private router: Router, private personSearchService: PersonSearchService) { }

  ngOnInit(): void {
      this.searchKeyword = this.route.snapshot.queryParamMap.get('keyword');
      this.selectedIndustries = this.route.snapshot.queryParamMap.get('industry') ? [this.route.snapshot.queryParamMap.get('industry')] : [];
      if (this.searchKeyword) {
        this.typeahead_search.patchValue(this.searchKeyword);
        this.getrecommededcompanylist();
      } else {
        this.getrecommededcompanylist();
      }

      this.typeAheadSubject.pipe(debounceTime(500)).subscribe(({event, type})=>{
        if(type == 'typeahead_search') {
          this.getTypeaheads(event);
          return;
        }
        this.getFilterTypeaheads(event,type);
      })
     
  }

  getrecommededcompanylist() {
    let payload = {
      startindex: 0,
      resultsize: this.companypagecount,
      searchviaboolean: true,
      booleanquery: this.searchKeyword ? this.searchKeyword: '*',
      industries: this.selectedIndustries,
      locations: this.selectedHqLocation,
      companysizes: this.selectedCompanysize,
      sortby: 'employeecountdesc',
      companybuckettypes: ["Fortun500"]
    }
    if(this.selectedIndustries.length > 0) delete payload.companybuckettypes;
    this.CompanyInsightsService.getRecommendedcompanies(payload).subscribe((res:any)=>{
      if(res.status == "success") {
        this.companylist = res.data.results.map(c => ({ ...c, tags: c.tags ? c.tags.sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase())) : [] }));
        this.companycount = res.data.totalresultscount
        
      }
   })
  }

  getTypeaheads(event) {
    const input = event.target.value
    this.typeaheaddata = [];
    this.showSearchLoader= true
    if(input) {
      this.CompanyInsightsService.getCompanyTypeaheads(input).subscribe((res:any)=>{
        // this.typeaheaddata = res.data
      const companyList = res.data;
      this.personSearchService.getCompanyLogo({ companynames: companyList.map(c => c.value)}).subscribe((response: any) => {
        this.typeaheaddata = companyList.map(c => ({ ...c, companylogo: response.message.filter(r => r.name === c.value)[0]?.companylogo }));
        this.showSearchLoader= false;
      });
      })
    } else {
      this.showSearchLoader= false;
      this.searchKeyword = '';
      this.getrecommededcompanylist();
    }
  }

  selectTypeahead(data) {
    this.typeahead_search = data.value
    this.searchKeyword = data.value;
    if(data.id) {
        this.router.navigate([`/company-details/${data.id}`])    
    } else
    this.getrecommededcompanylist()
  }

  getFilterTypeaheads(type, input) {
    this.industry_typeaheads = [];
    this.companysize_typeaheads = [];
    this.hqlocations_typeaheads = [];
    this.typeaheadObj= {
      startindex: 0,
      resultsize: 10,
      searchviaboolean: true,
      booleanquery: "*",
      industries: this.selectedIndustries,
      locations: this.selectedLocations,
      companysizes: this.selectedCompanysize,
      ...(this.searchKeyword && { companynames: this.companylist.map(c => c.name) })
    }
    if(type == 'industry') {
      this.typeaheadObj['typeahead'] = 'typeahead_industry'
      this.typeaheadObj['input'] = input
      this.showIndustryLoader= true
      this.CompanyInsightsService.getIndustryAggregates(this.typeaheadObj).subscribe((res:any)=>{
        if(res.status == "success") {
          this.industry_typeaheads = res.data.aggs
      this.showIndustryLoader= false

        }
      })
    } else if(type == 'companysize') {
      this.typeaheadObj['typeahead'] = 'typeahead_companysize'
      this.typeaheadObj['input'] = input
      this.showCompanysizeLoader= true
      this.CompanyInsightsService.getIndustryAggregates(this.typeaheadObj).subscribe((res:any)=>{
        if(res.status == "success") {
          this.companysize_typeaheads = res.data.aggs
      this.showCompanysizeLoader= false

        }
      })
    } else if(type == 'location') {
      this.typeaheadObj['typeahead'] = 'typeahead_location'
      this.typeaheadObj['input'] = input
      this.showLocationLoader= true
      this.CompanyInsightsService.getIndustryAggregates(this.typeaheadObj).subscribe((res:any)=>{
        if(res.status == "success") {
          this.hqlocations_typeaheads = res.data.aggs
      this.showLocationLoader= false
        }
      })
    }


  }

  onTypeAheadSearch(event, type){
    this.typeAheadSubject.next({event, type});
  }

  selectOption(value, type) {
    if(type == 'industry') {
      this.selectedIndustries.push(value.key)
      this.companyfilter_form.patchValue({industry: null})
    } else if(type == 'companysize') {
      this.selectedCompanysize.push(value.key)
      this.companyfilter_form.patchValue({companysize: null})
    } else if(type == 'location') {
      this.selectedHqLocation.push(value.key)
      this.companyfilter_form.patchValue({hqlocation: null})
    }
    this.getrecommededcompanylist()
  }

  redirecttoCompanylist(company) {
    this.CompanyInsightsService.setCompanyListData(company);

    this.router.navigate([`/company-details/${company.id}`])
  }

  unselect(data, type) {
    if(type == 'industry') {
      this.selectedIndustries = _.without(this.selectedIndustries, data)
    } else if(type == 'companysize') {
      this.selectedCompanysize = _.without(this.selectedCompanysize, data)
    } else if(type == 'location') {
      this.selectedHqLocation = _.without(this.selectedHqLocation, data)
    }
    this.getrecommededcompanylist()
  }

  clearAll() {
    this.companyfilter_form.patchValue({
      industry: null,
      companysize: null,
      hqlocation: null
    })
    this.selectedIndustries = []
    this.selectedCompanysize = []
    this.selectedHqLocation = []
    this.getrecommededcompanylist();
  }

  viewAllCompanyListing() {
    if (this.isViewMore) {
      this.companypagecount += 12;
      this.getrecommededcompanylist();
    } else {
      this.isViewMore = true;
      this.companypagecount = this.companypagecount - 12;
      this.getrecommededcompanylist()
    }
  }

  searchCompanies() {
    const inputkeyword = this.typeaheaddata.filter(x=>x.value.toLowerCase() == this.typeahead_search.value.toLowerCase())
    if(inputkeyword.length > 0) {
      this.searchKeyword = this.typeahead_search.value
      this.getrecommededcompanylist()
    }

  }

  removeTypeahead(type: any){
    const maxLength = 3
    switch (type) {
      case 'typeahead_search': {
        if (!(this.typeahead_search && this.typeahead_search.value && this.typeahead_search.value.length >= maxLength)) {
          this.typeaheaddata = []
        }
        break;
      }
    }
  }
  // sortCompanies(value: string) {
  //   this.companySortBy = value;
  //   this.getrecommededcompanylist();
  // }
}
